import React from "react"
import { ApolloProvider } from "@apollo/client"
import { client } from "./client"
import AuthWrapper from "../authWrapper"

export const wrapRootElement = ({ element }) => {
  return (
    <ApolloProvider client={client}>
      <AuthWrapper>{element}</AuthWrapper>
    </ApolloProvider>
  )
}
